import { render, staticRenderFns } from "./configEdit.vue?vue&type=template&id=049f0294"
import script from "./configEdit.vue?vue&type=script&lang=js"
export * from "./configEdit.vue?vue&type=script&lang=js"
import style0 from "./configEdit.vue?vue&type=style&index=0&id=049f0294&prod&lang=scss"
import style1 from "./configEdit.vue?vue&type=style&index=1&id=049f0294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports